import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React, { ComponentProps } from 'react';

import { Select as BlocksSelect } from '~/components/blocks';

const Root = styled(BlocksSelect)(
  ({ theme }) =>
    () =>
      css({
        '&:hover': {
          border: theme.borders.grey,
        },
        '&:focus': {
          border: theme.borders.grey,
        },
        '&:disabled': {
          '&:hover': {
            border: theme.borders.grey,
          },
        },
      }),
  ({ theme, error }) =>
    error &&
    css({
      backgroundColor: theme.colors.background.patientSecondary,
      color: theme.colors.colorPallete.patientRed,
      '&::placeholder': {
        color: theme.colors.text.placeholder,
      },
      '&:hover': {
        boxShadow: 0,
        border: theme.borders.error,
      },
      '&:focus': {
        boxShadow: 0,
        border: theme.borders.error,
        backgroundColor: theme.colors.background.default,
      },
    }),
);

type Props = ComponentProps<typeof BlocksSelect>;

export const Select = (props: Props) => {
  return <Root {...props} />;
};
